/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_A2Inputs */

const en_csv_to_json_faq_a2 = /** @type {(inputs: Csv_To_Json_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Fields enclosed in double quotes are parsed correctly, including fields containing commas, line breaks, and doubled double quotes as escaped quotes.`)
};

const ko_csv_to_json_faq_a2 = /** @type {(inputs: Csv_To_Json_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그렇습니다. 큰따옴표로 감싼 필드는 쉼표, 줄바꿈, 그리고 이스케이프된 따옴표로서의 두 개짜리 큰따옴표를 포함해 올바르게 파싱됩니다.`)
};

const ja_csv_to_json_faq_a2 = /** @type {(inputs: Csv_To_Json_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。二重引用符で囲まれたフィールドは、カンマ、改行、そしてエスケープされた引用符としての 2 つ続いた二重引用符を含めて正しくパースされます。`)
};

/**
* | output |
* | --- |
* | "Yes. Fields enclosed in double quotes are parsed correctly, including fields containing commas, line breaks, and doubled double quotes as escaped quotes." |
*
* @param {Csv_To_Json_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_a2 = /** @type {((inputs?: Csv_To_Json_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_a2(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_a2(inputs)
	return ja_csv_to_json_faq_a2(inputs)
});